/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
import {
    Component,
    registerComponent
} from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';

const componentName = 'value-prop-grid-div';
const valueProp = 'cmp-value-prop';

export class ValuePropGrid extends Component {

    /**
     * Component Setup
     */

    selectors = {
        valuePropGrid: `.${componentName}`,
        valueProp: `.${valueProp}`,
        timelineSolutions: `.${valueProp}__timeline--solutions`,
        timelineValueProp: `.${valueProp}__timeline`,
        columnControlContainer: '.row',
        innerColumnWrapper: '.column-control',
        outerColumnWrapper: '',
        dataCategory: 'data-category'
    };

    elements = {
        solutionsList: this.element.querySelector(this.selectors.timelineSolutions),
        timelineValueProp: this.element.querySelector(this.selectors.timelineValueProp),
        valuePropComponent: this.element.querySelector(this.selectors.valueProp),
        valuePropGrid: this.element,
        currentCol: null,
        currentColumnControlDiv: null,
    };

    state = {
        categoryName: null,
        isWrappedByColumnControl: false,
        columnSize: 3
    };

    /**
     * Initialize Component
     */
    init = async () => {
        window.addEventListener('load', () => {
            window.valueProp = this; // TEMP: for debug purposes
            this.obtainState();
            if ((!isEditModeFooter()) && this.elements.timelineValueProp && this.state.isWrappedByColumnControl && (!this.elements.solutionsList)) {
                console.info('update column control for questionnaire report based on Value Prop Grid component');
                this.updateColumnControl();
                this.elements.currentCol.remove();
            }
        });
    };

    updateColumnControl = () => {
        if (this.state.columnSize === 4 && this.elements.currentCol.classList.contains('col-desktop-3')) {
            this.elements.currentColumnControlDiv.children.forEach((eachCol) => {
                eachCol.classList.remove('col-desktop-3');
                eachCol.classList.add('col-desktop-4');
            });
        } else if (this.state.columnSize === 3 && this.elements.currentCol.classList.contains('col-desktop-4')) {
            this.elements.currentColumnControlDiv.children.forEach((eachCol) => {
                eachCol.classList.remove('col-desktop-4');
                eachCol.classList.add('col-desktop-6');
            });
        } else if (this.state.columnSize === 2 && this.elements.currentCol.classList.contains('col-desktop-6')) {
            this.elements.currentColumnControlDiv.children.forEach((eachCol) => {
                eachCol.classList.remove('col-desktop-6');
            });
        } else {
            // TODO: extend for more columns => 'too many columns in configuration'
        }
    };

    obtainState = () => {
        this.elements.innerCol = this.element.closest(this.selectors.innerColumnWrapper);
        if (this.elements.innerCol && this.elements.innerCol.parentElement.classList.contains(this.selectors.outerColumnWrapper)) {
            this.elements.currentCol = this.elements.innerCol.parentElement;
            this.elements.currentColumnControlDiv = this.elements.currentCol.closest(this.selectors.columnControlContainer);
        }
        if (this.elements.currentCol && this.elements.currentColumnControlDiv) {
            this.state.isWrappedByColumnControl = true;
            this.state.columnSize = this.elements.currentColumnControlDiv.childElementCount;
            this.state.categoryName = this.elements.timelineValueProp ? this.elements.timelineValueProp.getAttribute(this.selectors.dataCategory) : 'no timeline value prop';
        }
    };

}

registerComponent(`.${componentName}`, ValuePropGrid);
